
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 14H5.33333C5.15753 14.0005 4.98339 13.9661 4.82092 13.8989C4.65845 13.8318 4.51087 13.7331 4.38667 13.6087L1.724 10.9427C1.47404 10.6927 1.33362 10.3536 1.33362 10C1.33362 9.6465 1.47404 9.30742 1.724 9.05738L8.39067 2.39072C8.51449 2.26685 8.6615 2.16859 8.8233 2.10155C8.9851 2.03451 9.15853 2 9.33367 2C9.50881 2 9.68223 2.03451 9.84404 2.10155C10.0058 2.16859 10.1528 2.26685 10.2767 2.39072L14.276 6.39072C14.526 6.64075 14.6664 6.97983 14.6664 7.33338C14.6664 7.68693 14.526 8.02601 14.276 8.27605L8.556 14","stroke":"currentColor","stroke-width":"1.33333","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.38794 7.39355L9.27327 13.2789","stroke":"currentColor","stroke-width":"1.33333","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    